module.exports = __webpack_public_path__ + "img/login__logo.ed56cf75.svg";